import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Main from '../components/Main/Main';
import DirectoryTabs from '../components/DirectoryTabs/DirectoryTabs';
import GenerateAttendeeReport from '../components/Reports/GenerateAttendeeReport';
import ErrorPage from '../components/ErrorPage/Error';
import AuthConfirm from '../components/AuthConfirmationPage/AuthConfirm.js';
import Layout from '../container/Layout';
import RedirectTo from '../components/RedirectTo/RedirectTo';
import ErrorPageDecisionMaker from '../components/ErrorPageDecisionMaker/ErrorPageDecisionMaker';
import {
  ERROR_TYPE_AUTH,
  ERROR_TYPE_PANEL_MSG,
  ERROR_TYPE_INITIALIZATION_ERROR,
  ERROR_TYPE_APP_UNAVAILABLE,
  INTEGRATED_APP_UNAVAILABLE,
  NON_INTEGRATED_APP_UNAVAILABLE
} from '../constants/error.constants';
import { DOWNLOAD_POLL_REPORT_PAGE_PATH } from '../constants/route.constants';
import PollReportDownloader from '../components/PollReport/PollReportDownloader.js';

const AppRouter = () => {
  return (
    <Routes>
      <Route element={<ErrorPageDecisionMaker />}>
        <Route exact path="/home" element={<Main />} />
        <Route exact path="/directory" element={<DirectoryTabs />} />
      </Route>
      <Route exact path="/download-attendee-report" element={<GenerateAttendeeReport />} />
      <Route exact path={`/${DOWNLOAD_POLL_REPORT_PAGE_PATH}`} element={<PollReportDownloader />} />
      <Route element={<Layout />}>
        <Route exact path="/unauthorized" element={<ErrorPage />} />
        <Route exact path="/authenticated" element={<AuthConfirm type={ERROR_TYPE_AUTH} />} />
        <Route exact path="/panelmessage" element={<AuthConfirm type={ERROR_TYPE_PANEL_MSG} />} />
        <Route exact path="/error" element={<AuthConfirm type={ERROR_TYPE_INITIALIZATION_ERROR} />} />
        <Route exact path="/appunavailable" element={<AuthConfirm type={ERROR_TYPE_APP_UNAVAILABLE} />} />
        <Route exact path="/integratedunavailable" element={<AuthConfirm type={INTEGRATED_APP_UNAVAILABLE} />} />
        <Route exact path="/nonintegratedunavailable" element={<AuthConfirm type={NON_INTEGRATED_APP_UNAVAILABLE} />} />
        <Route exact path="/directoryunavailable" element={<ErrorPage />} />
        <Route exact path="/redirect" element={<RedirectTo />} />
        <Route path="*" element={<ErrorPage />} />
      </Route>
    </Routes>
  );
};

export default AppRouter;
